export var VERSION = '2.23.7';
//# sourceMappingURL=version.js.map